const Theme = {
  color1: "#56afd2",
};

export default Theme;
